import PropTypes from "prop-types";
import React from "react";

export default function SignUpText(props) {
  const { form1, form2, form3 } = props;
  return (
    <div>
      {form1 ? (
        <div className="sign-up-form-text">
          <div className="sign-up-form-text-group">
            <h1 className="sign-up-form-text-heading">Sign Up</h1>
            <p className="sign-up-form-text-subheading">
              Get started <br /> with your application
            </p>
          </div>
        </div>
      ) : form2 ? (
        <div className="sign-up-form-text">
          <div className="sign-up-form-text-group">
            <p className="sign-up-form-text-subheading">
              Hello, welcome <br /> to<span id="nibss"> NIBSS </span>
            </p>
            <p className="sign-up-form-text-paragraph">
              Tell us a bit about your company, to get you started
            </p>
          </div>
        </div>
      ) : form3 ? (
        <div className="sign-up-form-text">
          <div className="sign-up-form-text-group">
            <p className="sign-up-form-text-subheading">
              Select your <br /> business type
            </p>
            <p className="sign-up-form-text-paragraph">
              Here you can select a business category and upload company logo.
            </p>
          </div>
        </div>
      ) : (
        <div className="sign-up-form-text">
          <div className="sign-up-form-text-group">
            <p className="sign-up-form-text-subheading">
              Finally, provide a <br /> network admin
            </p>
            <p className="sign-up-form-text-paragraph">
              You required to provide a network admin who will perform all
              network operations or request
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

SignUpText.propTypes = {
  form1: PropTypes.any,
  form2: PropTypes.any,
  form3: PropTypes.any,
};
